// Fonction locale (au lieu d'un import @theme/utilities) : le menu ne dépend d'aucun autre fichier pour démarrer.
function isClickedOutside(event, element) {
  if (event.target instanceof HTMLDialogElement || !(event.target instanceof Element)) {
    const r = element.getBoundingClientRect();
    return !(event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom);
  }

  return !element.contains(event.target);
}

class DropdownGroupComponent extends HTMLElement {
  constructor() {
    super();

    this.dropdowns = [];
  }

  connectedCallback() {
    this.dropdowns = this.querySelectorAll('dropdown-component');

    document.addEventListener('click', this.#handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.#handleDocumentClick);
  }

  #handleDocumentClick = (event) => {
    const clickedInsideDropdown = event.target.closest('dropdown-component');
    if (!clickedInsideDropdown) {
      this.closeAllDropdowns();
    }
  };

  closeAllDropdowns() {
    this.dropdowns.forEach((dropdown) => {
      dropdown.close();
    });
  }
}

if (!customElements.get('dropdown-group-component')) {
  customElements.define('dropdown-group-component', DropdownGroupComponent);
}

class DropdownComponent extends HTMLElement {
  #hoverTimer = null;
  #hoverOpened = false;

  constructor() {
    super();

    this.toggle = null;
    this.content = null;
    this.isOpen = false;
  }

  connectedCallback() {
    this.toggle = this.querySelector('[data-ref="dropdown-toggle"]');
    this.content = this.querySelector('[data-ref="dropdown-content"]');

    this.toggle?.addEventListener('click', this.#handleToggle);

    // Menu principal : ouverture au survol de la souris (le clic reste possible)
    if (this.classList.contains('header__menu-item')) {
      this.addEventListener('pointerenter', this.#handlePointerEnter);
      this.addEventListener('pointerleave', this.#handlePointerLeave);
    }
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.#handleToggle);
    this.removeEventListener('pointerenter', this.#handlePointerEnter);
    this.removeEventListener('pointerleave', this.#handlePointerLeave);
    clearTimeout(this.#hoverTimer);
  }

  #handlePointerEnter = (event) => {
    if (event.pointerType !== 'mouse') return;

    clearTimeout(this.#hoverTimer);

    if (!this.isOpen) {
      this.closest('dropdown-group-component')?.closeAllDropdowns();
      this.open();
      this.#hoverOpened = true;
    }
  };

  #handlePointerLeave = (event) => {
    if (event.pointerType !== 'mouse' || !this.#hoverOpened) return;

    // Petit délai pour pouvoir passer du bouton au sous-menu sans qu'il se referme
    clearTimeout(this.#hoverTimer);
    this.#hoverTimer = setTimeout(() => {
      if (this.#hoverOpened) this.close();
    }, 250);
  };

  #handleToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();

    // Clic sur un menu déjà ouvert au survol : on le garde ouvert au lieu de le refermer
    if (this.isOpen && this.#hoverOpened) {
      this.#hoverOpened = false;
      clearTimeout(this.#hoverTimer);
      return;
    }

    if (this.isOpen) {
      this.close();
    } else {
      this.closest('dropdown-group-component')?.closeAllDropdowns();
      this.open();
    }
  };

  #handleClickOutside = (event) => {
    if (isClickedOutside(event, this)) {
      this.close();
    }
  };

  open() {
    this.setAttribute('data-open', 'true');
    document.addEventListener('click', this.#handleClickOutside);
    this.isOpen = true;
  }

  close() {
    this.setAttribute('data-open', 'false');
    document.removeEventListener('click', this.#handleClickOutside);
    this.isOpen = false;
    this.#hoverOpened = false;
    clearTimeout(this.#hoverTimer);
  }
}

if (!customElements.get('dropdown-component')) {
  customElements.define('dropdown-component', DropdownComponent);
}
